import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { FC } from 'react';

const LoaderWrapper = styled('div')({
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1301,
    width: '100%'
});

const Loader: FC = () => (
    <LoaderWrapper>
        <LinearProgress color="secondary" />
    </LoaderWrapper>
);

export default Loader;
